import { Link } from 'react-router-dom'
import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import { colors, typography } from '@resiliatech/birdsong'

export const Back = styled(Link)`
  align-items: center;
  color: ${colors.interactive.primaryEnabled};
  display: flex;
  text-decoration: none;
  width: fit-content;

  @media print {
    display: none;
  }
`

export const BackText = styled(Typography)`
  ${typography.baseline.semiBoldSans}
`
